/* eslint-disable */

import { NavLink, useLocation } from 'react-router-dom';
// chakra imports
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  HStack,
  Text,
  List,
  ListItem,
  useColorModeValue,
  useToken,
} from '@chakra-ui/react';

export function SidebarLinks(props: {
  routes: RoutesType[];
  hovered?: boolean;
  mini?: boolean;
}) {
  const location = useLocation();
  const { routes, hovered, mini } = props;
  const activeColor = useColorModeValue('gray.800', 'white');
  const inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  const activeIcon = useColorModeValue('brand.800', 'white');
  const [brand800] = useToken('colors', ['brand.800']);

  const hexToRgba = (hex: string, alpha: number) => {
    const h = hex.replace('#', '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const activeBg = hexToRgba(brand800, 0.18);
  const isRouteActive = (path: string, layout?: string) => {
    const fullPath = `${layout || ''}${path}`.toLowerCase();
    return location.pathname.toLowerCase().startsWith(fullPath);
  };

  const isParentActive = (items?: RoutesType[]) =>
    items?.some(item => isRouteActive(item.path, item.layout));

  const createAccordionLinks = (routes: RoutesType[]) =>
    routes.map((route, key) => {
      const active = isRouteActive(route.path, route.layout);

      return (
        <NavLink to={route.layout + route.path} end key={key}>
          <ListItem
            ms={
              mini === false
                ? '26px'
                : mini && hovered
                ? '26px'
                : '0px'
            }
            mb="4px"               
            px="10px"
            py="6px"
            borderRadius="10px"
            bg={active ? activeBg : 'transparent'}
          >
            <Text
              fontSize="sm"
              fontWeight={active ? '700' : '500'}
              color={active ? activeColor : inactiveColor}
            >
              {mini === false
                ? route.name
                : mini && hovered
                ? route.name
                : route.name[0]}
            </Text>
          </ListItem>
        </NavLink>
      );
    });

 
  const createLinks = (routes: RoutesType[]) =>
    routes.map((route, key) => {
      if (route.collapse) {
        const parentActive = isParentActive(route.items);

        return (
          <Accordion
            key={key}
            allowToggle
            defaultIndex={parentActive ? 0 : -1}
            mb="2px"               
          >
            <AccordionItem border="none">
              <AccordionButton
                px="10px"
                py="8px"           
                borderRadius="12px"
                bg={parentActive ? activeBg : 'transparent'}
                _hover={{ bg: activeBg }}
                _focus={{ boxShadow: 'none' }}
              >
                <Flex w="100%" align="center" justify="space-between">
                  <HStack spacing="12px">
                    <Box
                      color={parentActive ? activeIcon : inactiveColor}
                    >
                      {route.icon}
                    </Box>

                    <Text
                      display={
                        mini === false
                          ? 'block'
                          : mini && hovered
                          ? 'block'
                          : 'none'
                      }
                      fontWeight={parentActive ? '700' : '500'}
                      color={parentActive ? activeColor : inactiveColor}
                    >
                      {route.name}
                    </Text>
                  </HStack>

                  <AccordionIcon
                    display={
                      mini === false
                        ? 'block'
                        : mini && hovered
                        ? 'block'
                        : 'none'
                    }
                  />
                </Flex>
              </AccordionButton>

              <AccordionPanel px="0" pt="4px" pb="4px">
                <List spacing={0}>{createAccordionLinks(route.items)}</List>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        );
      }


      const active = isRouteActive(route.path, route.layout);

      return (
        <NavLink to={route.layout + route.path} end key={key}>
          <Flex
            align="center"
            px="10px"
            py="8px"
            mb="2px"               
            borderRadius="12px"
            bg={active ? activeBg : 'transparent'}
            _hover={{ bg: activeBg }}
          >
            <Box
              me="12px"
              color={active ? activeIcon : inactiveColor}
            >
              {route.icon}
            </Box>

            <Text
              display={
                mini === false
                  ? 'block'
                  : mini && hovered
                  ? 'block'
                  : 'none'
              }
              fontWeight={active ? '700' : '500'}
              color={active ? activeColor : inactiveColor}
            >
              {route.name}
            </Text>
          </Flex>
        </NavLink>
      );
    });
    

  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
